module.exports = __webpack_public_path__ + "static/img/Skye.478ec4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/crs/Skye.png
// module id = LMo3
// module chunks = 0